import { useLocation } from 'react-router-dom';
import { MENU_LIST_ITEM, MenuItemType } from 'utils';

export function useActiveMenu() {
  const location = useLocation();
  const pathnameArr = location.pathname.replace('/', '').split('/');
  const getSelectedKeys = (
    items: MenuItemType[],
    path: string
  ): { selectedMenu?: string; selectedSubMenu?: string } => {
    for (let item of items) {
      if (item.children) {
        for (let child of item.children) {
          if (typeof child.href === 'string' ? child.href === path : child.href?.includes(path)) {
            return { selectedMenu: item.key, selectedSubMenu: child.key };
          }
        }
      }
      if (typeof item.href === 'string' ? item.href === path : item.href?.includes(path)) {
        return { selectedMenu: item.key };
      }
    }
    return {};
  };
  return getSelectedKeys(MENU_LIST_ITEM, `/${pathnameArr[0]}`);
}
